import React, { useEffect } from 'react';
import withPageComponents from '../../../page/components/with-page-components';
import usePageLoader from '../../../hooks/usePageLoader';

/**
 * Component for managing CTO loader state
 */
export default withPageComponents(
    ({ verifyingPicks }) => {
        const [loader, setLoader] = usePageLoader();
        useEffect(() => {
            if (verifyingPicks) {
                setLoader({ loading: true });
            } else if (!verifyingPicks) {
                setTimeout(() => {
                    setLoader({ loading: false });
                }, 0);
            }
        }, [verifyingPicks]);

        return null;
    },
    {
        components: ['verifyingPicks'],
    },
);
